<div>
  <app-container [error]="errNo" [loading]="isLoading">

  </app-container>
</div>
